<template>
	<v-app :dark="$store.state.user.preferences.dark_mode">
		<LoginScreen v-if="!$store.state.splashscreen && !$store.state.user.logged_in" />
		<MainScreen v-else-if="!$store.state.splashscreen && $store.state.user.logged_in" />
		<SplashLoadingScreen v-else />
	</v-app>
</template>

<script>
import LoginScreen from "./components/LoginScreen";
import MainScreen from "./components/MainScreen";
import SplashLoadingScreen from "./components/SplashLoadingScreen";

export default {
	name: "App",
	components: {
		LoginScreen,
		MainScreen,
		SplashLoadingScreen
	},
	created() {
		const I = this;
		//CHECK LOGGED IN?
		console.info("Checking logged in?");
		this.$on("pouchdb-db-destroyed", function(e) {
			console.warn("DESTROYED!", e);
			// recreate db??
			I.$pouch.getSession().then(r => {
				console.warn("Session?", r);
				// I.$pouch.PouchDB = new PouchDB();
				console.warn("POUCH?", I.$pouch);
			});
		});
		this.$pouch
			.get("guest")
			.then(doc => {
				console.warn("Guest was found - LOADING!:", doc);
				if (!doc.logged_in) {
					console.warn("Not logged in!");
					I.$store.state.splashscreen = false;
				} else {
					I.$store
						.dispatch("logIn", {
							pouch: this.$pouch,
							username: doc.username
						})
						.then(() => {
							I.$store.state.splashscreen = false;
						});
				}
			})
			.catch(e => {
				I.$store.state.splashscreen = false;
				console.warn("Guest was NOT found - as you were!");
				//I.$store.dispatch("installTemplate");
				//I.$store.commit("logIn");
			});
	},
	data: () => ({
		//
	})
};
</script>
